"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));

var _EyeInput = require("./EyeInput.styles");

var _ValidationIcon = _interopRequireDefault(require("./ValidationIcon"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var EyeInput = function EyeInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      name = _ref.name,
      disabled = _ref.disabled,
      error = _ref.error,
      isValid = _ref.isValid,
      touched = _ref.touched,
      mask = _ref.mask,
      errorClassName = _ref.errorClassName,
      errorStyle = _ref.errorStyle,
      inputIcon = _ref.inputIcon,
      inputRightIcon = _ref.inputRightIcon,
      hideIcons = _ref.hideIcons,
      iconOffset = _ref.iconOffset,
      hideErrors = _ref.hideErrors,
      wrapperStyle = _ref.wrapperStyle,
      containerClassName = _ref.containerClassName,
      className = _ref.className,
      inputWrapperStyle = _ref.inputWrapperStyle,
      inputStyle = _ref.inputStyle,
      labelStyle = _ref.labelStyle,
      placeholder = _ref.placeholder,
      animateLabel = _ref.animateLabel,
      required = _ref.required,
      onKeyDown = _ref.onKeyDown,
      onClick = _ref.onClick,
      type = _ref.type,
      inputMode = _ref.inputMode,
      pattern = _ref.pattern,
      guide = _ref.guide,
      variant = _ref.variant,
      color = _ref.color,
      labelColor = _ref.labelColor,
      borderColor = _ref.borderColor,
      labelBackgroundColor = _ref.labelBackgroundColor,
      components = _ref.components,
      isMultiline = _ref.isMultiline,
      inputCss = _ref.inputCss;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      animated = _useState2[0],
      setAnimated = _useState2[1];

  var inputRef = (0, _react.useRef)(null);

  var shouldShowError = function shouldShowError() {
    return name && !hideErrors && error && touched;
  };

  var handleLabelClick = function handleLabelClick(e) {
    if (inputRef.current && inputRef.current.focus && typeof inputRef.current.focus === 'function') inputRef.current.focus();

    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  var handleFocus = function handleFocus(e) {
    if (onFocus) {
      onFocus(e);
    }

    setAnimated(true);
  };

  var handleBlur = function handleBlur(e) {
    if (onBlur) {
      onBlur(e);
    }

    if (!value) {
      setAnimated(false);
    }
  };

  var handleChange = function handleChange(e) {
    if (onChange) onChange(e);
  };

  (0, _react.useEffect)(function () {
    if (value) {
      setAnimated(true);
    } else {
      setAnimated(false);
    }
  }, [value]);

  var renderError = function renderError() {
    return components.Error ? components.Error(error) : (0, _core.jsx)("div", {
      css: _EyeInput.errorContainerCss,
      className: errorClassName,
      style: errorStyle
    }, error);
  };

  var renderInput = function renderInput(ref, props) {
    var maskedProps = props;
    var maskedClassName = maskedProps.className,
        maskedDisabled = maskedProps.disabled,
        maskedName = maskedProps.name,
        maskedOnBlur = maskedProps.onBlur,
        maskedOnChange = maskedProps.onChange,
        maskedOnFocus = maskedProps.onFocus,
        maskedPlaceholder = maskedProps.placeholder,
        maskedAriaLabel = maskedProps['aria-label'],
        maskedId = maskedProps.id;
    return (0, _core.jsx)(_EyeInput.StyledInput, {
      ref: (0, _composeReactRefs["default"])(inputRef, ref),
      id: maskedId,
      "aria-label": maskedAriaLabel,
      name: maskedName,
      value: value,
      className: maskedClassName,
      disabled: maskedDisabled,
      placeholder: maskedPlaceholder,
      onChange: maskedOnChange,
      onFocus: maskedOnFocus,
      onBlur: maskedOnBlur,
      hasError: !!error,
      valid: isValid,
      inputMode: inputMode,
      pattern: pattern,
      style: inputStyle,
      hasIcon: !!inputIcon,
      variant: variant,
      color: color,
      borderColor: borderColor,
      css: inputCss
    });
  };

  var renderIcon = function renderIcon() {
    return inputIcon && (0, _core.jsx)("span", {
      css: _EyeInput.iconCss
    }, inputIcon);
  };

  var renderRightIcon = function renderRightIcon() {
    return inputRightIcon && (0, _core.jsx)("span", {
      css: _EyeInput.rightIconCss
    }, inputRightIcon);
  };

  return (0, _core.jsx)("div", {
    className: containerClassName,
    css: _EyeInput.wrapperCss,
    style: wrapperStyle
  }, renderIcon(), renderRightIcon(), (0, _core.jsx)(_EyeInput.InputWrapper, {
    style: inputWrapperStyle
  }, animateLabel && (0, _core.jsx)(_EyeInput.InputLabel, {
    onClick: handleLabelClick,
    onKeyPress: handleLabelClick,
    htmlFor: "input-".concat(name),
    style: labelStyle,
    disabled: disabled,
    animated: animated,
    variant: variant,
    color: labelColor,
    backgroundColor: labelBackgroundColor
  }, required ? placeholder.concat('*') : placeholder), mask ? (0, _core.jsx)(_reactTextMask["default"], {
    id: "input-".concat(name),
    "aria-label": name,
    name: name,
    value: value,
    placeholder: !animateLabel ? placeholder : '',
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChange,
    onKeyDown: onKeyDown,
    onClick: onClick,
    ref: inputRef,
    disabled: disabled,
    className: className,
    mask: mask,
    maskChar: null,
    render: renderInput,
    type: type,
    guide: guide
  }) : (0, _core.jsx)(_EyeInput.StyledInput, {
    id: "input-".concat(name),
    "aria-label": name,
    name: name,
    value: value,
    placeholder: !animateLabel ? placeholder : '',
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChange,
    onKeyDown: onKeyDown,
    onClick: onClick,
    ref: inputRef,
    disabled: disabled,
    className: className,
    hasError: !!error,
    valid: isValid,
    type: type,
    inputMode: inputMode,
    pattern: pattern,
    style: inputStyle,
    hasIcon: !!inputIcon,
    hasRightIcon: !!inputRightIcon,
    variant: variant,
    color: color,
    borderColor: borderColor,
    as: isMultiline && 'textarea',
    css: inputCss
  }), !hideIcons && touched && (isValid || error) && (0, _core.jsx)(_ValidationIcon["default"], {
    error: !!error,
    iconOffset: iconOffset,
    hasRightIcon: !!inputRightIcon
  }), shouldShowError() && renderError()));
};

EyeInput.defaultProps = {
  animateLabel: false,
  value: '',
  onChange: undefined,
  onBlur: undefined,
  onFocus: undefined,
  disabled: false,
  hideIcons: true,
  hideErrors: false,
  inputIcon: undefined,
  inputRightIcon: undefined,
  iconOffset: undefined,
  wrapperStyle: undefined,
  inputWrapperStyle: undefined,
  containerClassName: undefined,
  className: undefined,
  error: null,
  errorStyle: undefined,
  errorClassName: undefined,
  inputStyle: undefined,
  labelStyle: undefined,
  placeholder: undefined,
  touched: false,
  required: false,
  isValid: false,
  name: '',
  mask: false,
  onKeyDown: undefined,
  onClick: undefined,
  type: 'text',
  inputMode: undefined,
  pattern: undefined,
  guide: true,
  variant: 'default',
  color: undefined,
  borderColor: undefined,
  labelBackgroundColor: undefined,
  labelColor: undefined,
  components: {},
  isMultiline: false,
  inputCss: undefined
};
EyeInput.propTypes = {
  animateLabel: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  containerClassName: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  errorClassName: _propTypes["default"].string,
  errorStyle: _propTypes["default"].object,
  hideErrors: _propTypes["default"].bool,
  hideIcons: _propTypes["default"].bool,
  iconOffset: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  inputIcon: _propTypes["default"].node,
  inputRightIcon: _propTypes["default"].node,
  inputWrapperStyle: _propTypes["default"].object,
  isValid: _propTypes["default"].bool,
  labelStyle: _propTypes["default"].object,
  inputStyle: _propTypes["default"].object,
  name: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  touched: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  wrapperStyle: _propTypes["default"].object,
  mask: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].array, _propTypes["default"].func]),
  onKeyDown: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  type: _propTypes["default"].string,
  inputMode: _propTypes["default"].string,
  pattern: _propTypes["default"].string,
  guide: _propTypes["default"].bool,
  variant: _propTypes["default"].string,
  color: _propTypes["default"].string,
  labelColor: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  labelBackgroundColor: _propTypes["default"].string,
  components: _propTypes["default"].shape({
    Error: _propTypes["default"].func
  }),
  isMultiline: _propTypes["default"].bool,
  inputCss: _propTypes["default"].string
};
var _default = EyeInput;
exports["default"] = _default;

//# sourceMappingURL=EyeInput.js.map